// billing.reducer.js
import { billingConstants } from "../actions/constants";

const initState = {
    loading: false,
    topupLoading: false,
    promoLoading: false,
    sceneLoading: false,
    sceneAccessLoading: false,
    subscriptionLoading: false,
    subscriptionCancelLoading: false,
    subscriptionAutoRenewLoading: false,
    transferLoading: false,

    error: null,
    message: "",
    showAlert: false,
    variantAlert: "success",

    paymentUrl: "",
    paymentId: "",
    transactions: [],

    lastTopUp: null,
    lastPromo: null,
    lastScenePayment: null,
    lastSceneAccessPayment: null,
    lastSubscription: null,
    lastTransfer: null,
};

export default (state = initState, action) => {
    switch (action.type) {
        case billingConstants.INIT_TOPUP_REQUEST:
            return {
                ...state,
                loading: true,
                topupLoading: true,
                error: null,
                showAlert: false,
            };

        case billingConstants.INIT_TOPUP_SUCCESS:
            return {
                ...state,
                loading: false,
                topupLoading: false,
                paymentUrl: action.payload?.paymentUrl || "",
                paymentId: action.payload?.paymentId || "",
                lastTopUp: action.payload || null,
                message: action.payload?.message || "Операция выполнена",
                showAlert: true,
                variantAlert: "success",
            };

        case billingConstants.INIT_TOPUP_FAILURE:
            return {
                ...state,
                loading: false,
                topupLoading: false,
                error: action.payload?.error || "Ошибка пополнения",
                message: action.payload?.error || "Ошибка пополнения",
                showAlert: true,
                variantAlert: "warning",
            };

        case billingConstants.APPLY_PROMO_REQUEST:
            return {
                ...state,
                loading: true,
                promoLoading: true,
                error: null,
                showAlert: false,
            };

        case billingConstants.APPLY_PROMO_SUCCESS:
            return {
                ...state,
                loading: false,
                promoLoading: false,
                lastPromo: action.payload || null,
                message: action.payload?.message || "Промокод активирован",
                showAlert: true,
                variantAlert: "success",
            };

        case billingConstants.APPLY_PROMO_FAILURE:
            return {
                ...state,
                loading: false,
                promoLoading: false,
                error: action.payload?.error || "Ошибка активации промокода",
                message: action.payload?.error || "Ошибка активации промокода",
                showAlert: true,
                variantAlert: "warning",
            };

        case billingConstants.PAY_SCENE_REQUEST:
            return {
                ...state,
                loading: true,
                sceneLoading: true,
                error: null,
                showAlert: false,
            };

        case billingConstants.PAY_SCENE_SUCCESS:
            return {
                ...state,
                loading: false,
                sceneLoading: false,
                lastScenePayment: action.payload || null,
                message: action.payload?.message || "Сцена оплачена",
                showAlert: true,
                variantAlert: "success",
            };

        case billingConstants.PAY_SCENE_FAILURE:
            return {
                ...state,
                loading: false,
                sceneLoading: false,
                error: action.payload?.error || "Ошибка оплаты сцены",
                message: action.payload?.error || "Ошибка оплаты сцены",
                showAlert: true,
                variantAlert: "warning",
            };

        case billingConstants.PAY_SCENE_ACCESS_REQUEST:
            return {
                ...state,
                loading: true,
                sceneAccessLoading: true,
                error: null,
                showAlert: false,
            };

        case billingConstants.PAY_SCENE_ACCESS_SUCCESS:
            return {
                ...state,
                loading: false,
                sceneAccessLoading: false,
                lastSceneAccessPayment: action.payload || null,
                message: action.payload?.message || "Разовая сцена оплачена",
                showAlert: true,
                variantAlert: "success",
            };

        case billingConstants.PAY_SCENE_ACCESS_FAILURE:
            return {
                ...state,
                loading: false,
                sceneAccessLoading: false,
                error: action.payload?.error || "Ошибка оплаты разовой сцены",
                message: action.payload?.error || "Ошибка оплаты разовой сцены",
                showAlert: true,
                variantAlert: "warning",
            };

        case billingConstants.GET_TRANSACTIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case billingConstants.GET_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                transactions: Array.isArray(action.payload) ? action.payload : [],
            };

        case billingConstants.GET_TRANSACTIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.error || "Ошибка загрузки истории операций",
                message: action.payload?.error || "Ошибка загрузки истории операций",
                showAlert: true,
                variantAlert: "warning",
            };

        case billingConstants.BUY_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                loading: true,
                subscriptionLoading: true,
                error: null,
                showAlert: false,
            };

        case billingConstants.BUY_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                loading: false,
                subscriptionLoading: false,
                lastSubscription: action.payload || null,
                message: action.payload?.message || "Подписка активирована",
                showAlert: true,
                variantAlert: "success",
            };

        case billingConstants.BUY_SUBSCRIPTION_FAILURE:
            return {
                ...state,
                loading: false,
                subscriptionLoading: false,
                error: action.payload?.error || "Ошибка покупки подписки",
                message: action.payload?.error || "Ошибка покупки подписки",
                showAlert: true,
                variantAlert: "warning",
            };

        case billingConstants.CANCEL_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                subscriptionCancelLoading: true,
                error: null,
                showAlert: false,
            };

        case billingConstants.CANCEL_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                subscriptionCancelLoading: false,
                lastSubscription: action.payload || null,
                message: action.payload?.message || "Автопродление отключено",
                showAlert: true,
                variantAlert: "success",
            };

        case billingConstants.CANCEL_SUBSCRIPTION_FAILURE:
            return {
                ...state,
                subscriptionCancelLoading: false,
                error: action.payload?.error || "",
                message: action.payload?.error || "",
                showAlert: !!action.payload?.error,
                variantAlert: "warning",
            };

        case billingConstants.ENABLE_SUBSCRIPTION_AUTORENEW_REQUEST:
            return {
                ...state,
                subscriptionAutoRenewLoading: true,
                error: null,
                showAlert: false,
            };

        case billingConstants.ENABLE_SUBSCRIPTION_AUTORENEW_SUCCESS:
            return {
                ...state,
                subscriptionAutoRenewLoading: false,
                lastSubscription: action.payload || null,
                message: action.payload?.message || "Автопродление включено",
                showAlert: true,
                variantAlert: "success",
            };

        case billingConstants.ENABLE_SUBSCRIPTION_AUTORENEW_FAILURE:
            return {
                ...state,
                subscriptionAutoRenewLoading: false,
                error: action.payload?.error || "Ошибка включения автопродления",
                message: action.payload?.error || "Ошибка включения автопродления",
                showAlert: true,
                variantAlert: "warning",
            };

        case billingConstants.TRANSFER_TO_OFFICE_REQUEST:
            return {
                ...state,
                loading: true,
                transferLoading: true,
                error: null,
                showAlert: false,
            };

        case billingConstants.TRANSFER_TO_OFFICE_SUCCESS:
            return {
                ...state,
                loading: false,
                transferLoading: false,
                lastTransfer: action.payload || null,
                message: action.payload?.message || "Средства переведены на офис",
                showAlert: true,
                variantAlert: "success",
            };

        case billingConstants.TRANSFER_TO_OFFICE_FAILURE:
            return {
                ...state,
                loading: false,
                transferLoading: false,
                error: action.payload?.error || "Ошибка перевода средств",
                message: action.payload?.error || "Ошибка перевода средств",
                showAlert: true,
                variantAlert: "warning",
            };

        case billingConstants.CLOSE_BILLING_ALERT:
            return {
                ...state,
                showAlert: false,
            };

        default:
            return state;
    }
};
